exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".self-training-preview-dialog .el-dialog__body{padding:12px 20px 20px}", "", {"version":3,"sources":["/workspace/src/views/training/pages/course/SelfTrainingCourseTable.vue"],"names":[],"mappings":"AACA,+CAA+C,sBAAsB,CACpE","file":"SelfTrainingCourseTable.vue","sourcesContent":["\n.self-training-preview-dialog .el-dialog__body{padding:12px 20px 20px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52d0a626","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/training/pages/course/SelfTrainingCourseTable.vue
// module id = 5659
// module chunks = 150